import React from "react";
import styled from "styled-components";
import { theme } from "../../styles/theme";

const HeroContainer = styled.section`
  width: 100%;
  position: relative;
  background-image: url("./assets/images/background.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  overflow-x: hidden;
`;

const ContentWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 0 ${theme.spacing.lg} 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: 0 0 ${theme.spacing.md} 0;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 0 0 ${theme.spacing.sm} 0;
  }
`;

const TrendMicroHeader = styled.img`
  position: absolute;
  left: 0px;
  width: 200px;
  height: auto;
  z-index: 1001;

  @media (max-width: ${theme.breakpoints.tablet}) {
    width: 150px;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 100px;
  }
`;

const FixedPlayButton = styled.button`
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: 1000;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-50%) scale(1.05);
  }

  img {
    width: 220px;
    height: auto;
    display: block;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    right: 0;
    img {
      width: 180px;
    }
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    right: 0;
    img {
      width: 140px;
    }
  }
`;

const TitleWrapper = styled.div`
  position: relative;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
`;

const MainVisual = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const CatchCopy = styled.div`
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.8rem;
  color: ${theme.colors.text.primary};
  text-align: center;
  letter-spacing: 0.05em;
  white-space: nowrap;
  z-index: 2;

  @media (max-width: ${theme.breakpoints.desktop}) {
    font-size: 1.2rem;
    top: 89%;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    font-size: 0.9rem;
    top: 89%;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 0.9rem;
    top: 87%;
  }

  @media (max-width: 390px) {
    font-size: 0.85rem;
    top: 87%;
  }

  @media (max-width: 320px) {
    font-size: 0.7rem;
    top: 87%;
  }
`;

const CatchCopyImage = styled.img`
  width: 400px;
  height: auto;
  display: block;
  margin: 0 auto;

  @media (max-width: 1440px) {
    width: 330px;
  }

  @media (max-width: ${theme.breakpoints.desktop}) {
    width: 300px;
    margin-top: 20px;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    width: 200px;
    margin-top: 30px;
    margin-bottom: 0;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 150px;
    margin-top: 30px;
    margin-bottom: 0;
  }

  @media (max-width: 320px) {
    width: 140px;
    margin-top: 30px;
    margin-bottom: 0;
  }
`;

const HowToPlayButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-bottom: ${theme.spacing.xxl};
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  img {
    width: 320px;
    height: auto;
    display: block;
  }

  @media (max-width: 1440px) {
    margin-bottom: ${theme.spacing.lg};
    img {
      width: 240px;
      height: auto;
    }
  }

  @media (max-width: ${theme.breakpoints.desktop}) {
   margin-top: ${theme.spacing.xl};
    margin-bottom: ${theme.spacing.xl};
    img {
      width: 220px;
      height: auto;
    }
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    margin-top: ${theme.spacing.xl};
    margin-bottom: ${theme.spacing.xxl};
    img {
      width: 200px;
      height: auto;
    }
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    margin-bottom: ${theme.spacing.xxl};
    img {
      width: 140px;
      height: auto;
    }
  }

  @media (max-width: 390px) {
    margin-bottom: ${theme.spacing.xxl};
    img {
      width: 130px;
      height: auto;
    }
  }

  @media (max-width: 320px) {
    margin-bottom: ${theme.spacing.xxl};
    img {
      width: 110px;
      height: auto;
    }
  }
`;

const HeroSection: React.FC = () => {
  const handlePlayGame = () => {
    window.open(
      "https://go.trendmicro.com/jp/forHome/mktcp/bosagi/game/",
      "_blank"
    );
  };

  const handleHowToPlay = () => {
    const targetElement = document.getElementById("how-to-play");
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <HeroContainer>
      <TrendMicroHeader
        src="./assets/images/trendmicro_header.jpg"
        alt="Trend Micro"
        loading="lazy"
      />

      <FixedPlayButton onClick={handlePlayGame}>
        <img
          src="./assets/images/playing.png"
          alt="サギトレを遊ぶ"
          loading="lazy"
        />
      </FixedPlayButton>

      <ContentWrapper>
        <TitleWrapper>
          <MainVisual
            src="./assets/images/title_image.png"
            alt="サギトレ - 防詐欺訓練ゲーム"
            loading="lazy"
          />
          <CatchCopy>
            <CatchCopyImage
              src="./assets/images/hero_cacthcopy.png"
              alt="「防サギ訓練」とはなに！？"
              loading="lazy"
            />
            遊びながら詐欺を防ぐ力を身につけられるクイズゲームです。
          </CatchCopy>
        </TitleWrapper>

        <HowToPlayButton onClick={handleHowToPlay}>
          <img src="./assets/images/how2play.png" alt="遊び方" loading="lazy" />
        </HowToPlayButton>
      </ContentWrapper>
    </HeroContainer>
  );
};

export default HeroSection;
